import type { UpdatePaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTransfer = createApiThunk<string, { id: string; body: UpdatePaymentBody }>(
  "transfers/updateTransfer",
  async ({ id, body }: { id: string; body: UpdatePaymentBody }, { extra: { adminRepository } }) => {
    return adminRepository!.updateTransfer(id, body);
  },
);

export const resetUpdateTransfer = createAction("transfers/resetUpdateTransfer");
